export default __webpack_public_path__ + "static/media/partiallyFixed.ec06a24d.svg";